import React from 'react';
import Button from '../base/Button';
import { trackButtonClick } from '../../utils/analytics';
import './MidCTA.css';

function MidCTA() {
  const scrollToSignup = () => {
    trackButtonClick('Join the waitlist', 'mid_cta');
    const element = document.getElementById('signup');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="mid-cta">
      <div className="mid-cta-container">
        <h2 className="mid-cta-title title-1">
          Ready to work sustainably?
        </h2>
        <p className="mid-cta-subtitle body-text-secondary">
          Get started for free and take control of your focus, health, and productivity.
        </p>
        <Button 
          onClick={scrollToSignup} 
          variant="primary"
          className="mid-cta-button"
        >
          Join the waitlist
        </Button>
      </div>
    </section>
  );
}

export default MidCTA;

